/*
 * Copyright (C) 2022 Pitagon., JSC. - All Rights Reserved.
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

import {Component, HostBinding, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'ngx-pids-page-layout',
  template: '<ng-content></ng-content>',
  host: {
    class: 'ngx-pids-page-layout'
  },
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./page-layout.component.scss']
})
export class PageLayoutComponent {

  @Input() mode: 'card' | 'simple' = 'simple';

  constructor() {
  }

  @HostBinding('class.ngx-pids-page-layout-card')
  get isCard() {
    return this.mode === 'card';
  }

  @HostBinding('class.ngx-pids-page-layout-simple')
  get isSimple() {
    return this.mode === 'simple';
  }

}
